export default "__VITE_ASSET__49a3c9d2__"